import { Route, Routes } from "react-router-dom";
import PageLayout from "./components/pages/PageLayout";
// import Home from "./components/pages/Home";
import Login from "./components/pages/Login";
import Register from "./components/pages/Register";
import AllMemories from "./components/pages/AllMemories";
import ProfileDetails from "./components/pages/ProfileDetails";
import CreateProfile from "./components/pages/CreateProfile";
import About from "./components/pages/About";
import Martyrs from "./components/pages/Martyrs";
import Account from "./components/pages/Account";
import EditMemorialProfile from "./components/pages/EditMemorialProfile";
import PrivateRoute from "./PrivateRoute";
import Unauthorized from "./services/unauthorized";
import PaymentSuccess from "./components/pages/PaymentSuccess";
import AdminDashboard from "./components/dashboard/AdminDashboard";
import DashboardHome from "./components/dashboard/DashboardHome";
import UsersDashboard from "./components/dashboard/UsersDashboard";
import MemorialProfilesDashboard from "./components/dashboard/MemorialProfilesDashboard";
import EditMemorialProfileDashboard from "./components/dashboard/EditMemorialProfileDashboard";
import AnniversaryList from "./components/pages/AnniversaryList";
import Contact from "./components/pages/Contact";
import SettingsDashboard from "./components/dashboard/SettingsDashboad";
import useGtagPageView from "./services/useGtagPageView";
import SendNotificationDashboard from "./components/dashboard/SendNotificationDashboard";
import ForgotPassword from "./components/pages/ForgotPassword";
import ResetPassword from "./components/pages/ResetPassword";
import ReferralPageDashboard from "./components/dashboard/ReferralPageDashboard";


function Routing() {
  useGtagPageView('G-QZL6MDWE39');
  return (
    <Routes>
      <Route path="/" element={<PageLayout />}>
        <Route index element={<AllMemories />} />
        <Route path="giris" element={<Login />} />
        <Route path="qeydiyyat" element={<Register />} />
        <Route path="sifreni-unutdum" element={<ForgotPassword />} />
        <Route path="sifreni-sifirla" element={<ResetPassword />} />
        <Route path="butun-xatireler" element={<AllMemories />} />
        <Route path="sehidlerimiz" element={<Martyrs />} />
        <Route path="il-donumu" element={<AnniversaryList />} />
        <Route path="merhum/:id" element={<ProfileDetails />} />
        <Route path="xatire-yarat" element={<CreateProfile />} />
        <Route path="layihe-haqqinda" element={<About />} />
        <Route path="kabinetim" element={<Account />} />
        <Route path="redakte-et/:id" element={<EditMemorialProfile />} />
        <Route path="elaqe" element={<Contact />} />
        <Route path="/unauthorized" element={<Unauthorized />} />


      </Route>
      {/* ✅ Dashboard protected route */}
      <Route
        path="dashboard"
        element={
          <PrivateRoute allowedRoles={["admin", "moderator"]}>
            <AdminDashboard />
          </PrivateRoute>
        }
      >
        {/* Ana səhifə */}
        <Route index element={<DashboardHome />} />

        {/* İstifadəçi səhifəsi */}
        <Route path="users" element={<UsersDashboard />} />

        {/* Profillər səhifəsi */}
        <Route path="memorial-profiles" element={<MemorialProfilesDashboard />} />
        <Route path="referrals" element={<ReferralPageDashboard />} />
        {/* Parametrlər */}
        {/* <Route path="send-notification" element={<SendNotificationDashboard />} /> */}
        <Route path="memorial-profiles/:id/edit" element={<EditMemorialProfileDashboard />} />
        <Route path="settings" element={<SettingsDashboard />} />

      </Route>
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/unauthorized" element={<Unauthorized />} />

    </Routes >
  );
}

export default Routing;